import { PermissionService } from "src/services/permissionService/permissionService";

import { useCurrentWorkspace, useWorkspaceMemberRole } from "../api/helpers";

export function useWorkspacePageAccess() {
    const { data: workspace } = useCurrentWorkspace();
    const { workspaceAbility } = PermissionService();

    const role = useWorkspaceMemberRole();
    const canAccessSubscriptionTab = role === "Owner" || role === "Manager";
    const canAccessConfigurationTab = role === "Owner";
    const hasSubscription = Boolean(workspace?.subscription);
    const canViewSubscription = hasSubscription && canAccessSubscriptionTab;
    const allowedToEditWorkspace = workspace ? workspaceAbility(workspace).can("update", "Workspace") : false;

    return {
        workspace,
        role,
        hasSubscription,
        canViewSubscription,
        canAccessConfigurationTab,
        allowedToEditWorkspace,
    };
}
